import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Menu from '@material-ui/core/Menu'
import LogoutIcon from '@material-ui/icons/ExitToApp';
import LoginIcon from '@material-ui/icons/AccountCircle';
import InboxIcon from '@material-ui/icons/Inbox';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider'

import { useHistory } from 'react-router';

import useAuth from 'components/Auth/useAuth';
import useFunctions from 'components/Auth/useFunctions';
import useSharedDialog from 'components/SharedDialog/useSharedDialog';
import AuthStateContext from 'components/Auth/AuthStateContext';

import Button from './components/Button';
import MenuItem from './components/MenuItem';
import MenuTypography from './components/MenuTypography';

import useStore from 'components/Store/useStore';

const useStyles = makeStyles(theme => (
  {
    divider: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
    }
  }));

const SignInButton = {
    color : "inherit",
    label : "ログイン",
    "aria-label" : "ログインします。",
    component : 'a',
    icon : <LoginIcon />
  };

const SignOutButton = {
  color : "inherit",
  label : "ログアウト",
  "aria-label" : "ログアウトします。",
  component : 'a',
  icon : <LogoutIcon />
};

const SearchButton = {
  color : "inherit",
  label : "受信トレイ",
  "aria-label" : "メールアドレス宛に受信したドキュメントの一覧を開きます。",
  component : 'a',
  icon : <InboxIcon />
}

function BeforeSignIn(props)
{
  const {
    buttons
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = React.useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  /*
  const authContext = React.useContext(AuthStateContext);
  const functions = useFunctions();
  const sharedDialog = useSharedDialog();
  const handleSignIn = React.useCallback(() => {
    if (authContext.user && authContext.token) {
      // 既にGoogleにはログイン中でトークンが存在した場合、トークンのみ破棄します。
      functions.removeToken();
    }
    else {
      const signinDialog = sharedDialog("signin");
      signinDialog.open();
    }
  }, [authContext, sharedDialog]);
  */
  const functions = useFunctions();
  const handleSignIn = React.useCallback(() => {
    functions.removeToken();
  }, []);

  const classes = useStyles();
  const useMenu = useMediaQuery(theme => theme.breakpoints.down("xs"));
  const useIcon = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const [barButtons, menuButtons] = splitButtons(buttons, useMenu);

  const auth = useAuth();

  React.useEffect(() => {
    return handleClose;
  }
  , [props]);

  if (useMenu) {
    return (
      <React.Fragment>
        <Menubar buttons={barButtons} useIcon={useIcon}/>
        <IconButton onClick={handleClick}><MenuIcon /></IconButton> 
        <Menu id="icon-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          keepMounted>
            {
              menuButtons.map((button, index) =>
                <MenuItem {...button} key={index}/>
              )
            }
            { auth.noLogin ? null : <MenuItem {...SignInButton} onClick={handleSignIn} /> }
        </Menu>
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <Menubar buttons={barButtons} noLabel={useIcon}/>
        { auth.noLogin ? null : <Divider className={classes.divider} orientation='vertical' flexItem/> }
        { auth.noLogin ? null : <Button {...SignInButton} onClick={handleSignIn} /> }
      </React.Fragment>
    );
  }
}

function splitButtons(buttons, useMenu)
{
  if (!buttons || buttons.length === 0) return [[], []];

  let listButtons;
  let menuButtons;
  if (useMenu) {
    listButtons = buttons.filter(button => button.fixed);
    menuButtons = buttons.filter(button => !button.fixed);
  }
  else {
    listButtons = buttons;
  }

  return [listButtons, menuButtons];
}

const Menubar = React.forwardRef(function Menubar(props, ref)
{
  const {
    buttons,
    noLabel
  } = props;

  if (!buttons || buttons.length === 0) {
    return <div ref={ref}/>;
  }

  return (
    <div ref={ref}>
      { buttons.map((button, index) => (
        <Button key={index} noLabel={noLabel} {...button} />
      )) }
    </div>
  );
})

function AfterSignedIn(props)
{
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = React.useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  const [store, setStore] = useStore();
  const history = useHistory();
  const handleSearch = React.useCallback(() => {
    history.push("/inbox");
    setStore({...store, search:false, tab:store.tab??0});
  }, [history, store]);

  const functions = useFunctions();
  const handleSignOut = React.useCallback(() => {
    functions.signOut();
    setStore({search:false, tab:0});
    history.push("/");
  }, [functions]);

  const {
    buttons
  } = props;

  const auth = useAuth();
  const useMenu = useMediaQuery(theme => theme.breakpoints.down("xs"));
  const useIcon = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const [barButtons, menuButtons] = splitButtons(buttons, useMenu);
  const classes = useStyles();

  // ボタンクリック後に自動的にメニューを閉じるための処理
  // 状態更新の度に自動的に閉じる処理を挟む
  // NOTE: 今はないが、タイマー等で状態更新を挟む処理ができると勝手にメニューが閉じる原因になるかも
  React.useEffect(() => {
      return handleClose;
    }
  , [props]);

  if (useMenu) {
    return (
      <React.Fragment>
        <Menubar buttons={barButtons} useIcon={useIcon}/>
        <IconButton onClick={handleClick}><MenuIcon /></IconButton> 
  
        <Menu id="icon-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          keepMounted>
            <MenuTypography {...SignInButton} label={auth.name} optionLabel={auth.email} divider/>
            {
              menuButtons.map((button, index) =>
                <MenuItem {...button} key={index}/>
              )
            }
            {auth.emailVerified ? <MenuItem {...SearchButton} onClick={handleSearch} divider /> : null }
            <MenuItem {...SignOutButton} onClick={handleSignOut} />
        </Menu>
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <Menubar buttons={barButtons} noLabel={useIcon}/>
        { auth.emailVerified ? <Button {...SearchButton} noLabel={useIcon} onClick={handleSearch} /> : null }
        <Divider className={classes.divider} orientation='vertical' flexItem/>
        <Button {...SignInButton} label={auth.name} onClick={handleClick}/>
  
        <Menu id="icon-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          keepMounted>
            <MenuTypography {...SignInButton} label={auth.name} optionLabel={auth.email} divider/>
            { menuButtons ? menuButtons.map((button, index) =>
                    <MenuItem {...button} key={index}/>
                  ) : null }
            <MenuItem {...SignOutButton} onClick={handleSignOut} />
        </Menu>
      </React.Fragment>
    );
  }
}

export default function AppMenu(props)
{
  const auth = useAuth();
  if (auth.isUser) {
    return <AfterSignedIn {...props}/>;
  }
  return <BeforeSignIn  {...props}/>;
};